import React, { useMemo } from "react";
import { connect } from "react-redux";
import i18n from "i18next";
import { planTrainingBaseline } from "../../../workflow/planTrainingBaseline";
import { generateBaselineWorkflowAction } from "../../../../../common/actions";
import "./EmptyState.scss";

function EmptyState({ navItemsById, boxesById, pluginToolbarsById, onGenerate }) {
  const stats = useMemo(
    () => planTrainingBaseline(navItemsById, boxesById, pluginToolbarsById).stats,
    [navItemsById, boxesById, pluginToolbarsById]
  );
  return (
    <div className="flowviewer-empty-state">
      <div className="flowviewer-empty-state__inner">
        <div className="flowviewer-empty-state__title">
          ⫷ {i18n.t("Workflow.no_workflow_yet", { defaultValue: "No workflow yet" })}
        </div>
        <p className="flowviewer-empty-state__body">
          {i18n.t("Workflow.no_workflow_explainer", {
            defaultValue:
              "This training doesn't have any interaction rules. We can generate a baseline that mirrors your scene order and existing assessments — you can edit it after.",
          })}
        </p>
        <ul className="flowviewer-empty-state__stats">
          <li>
            ~{stats.triggers} triggers across {stats.sectionsNeedingWorkflow} sections
          </li>
          <li>~{stats.assessments} assessment auto-wirings</li>
          <li>~{stats.hotspots} hotspot jumps</li>
        </ul>
        <button
          type="button"
          className="btn"
          style={{ background: "#a963f5", color: "#fff" }}
          onClick={onGenerate}
        >
          <i className="material-icons">flash_on</i>{" "}
          {i18n.t("Workflow.generate_workflow", { defaultValue: "Generate Workflow" })}
        </button>
        <div className="flowviewer-empty-state__hint">
          {i18n.t("Workflow.fill_empties_hint", {
            defaultValue: "Sections that already have workflow rules will be skipped.",
          })}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const present = (state.undoGroup && state.undoGroup.present) || {};
  return {
    navItemsById: present.navItemsById || {},
    boxesById: present.boxesById || {},
    pluginToolbarsById: present.pluginToolbarsById || {},
  };
};
const mapDispatchToProps = (dispatch) => ({
  onGenerate: () => dispatch(generateBaselineWorkflowAction()),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmptyState);
